import { Component } from '@angular/core';

@Component({
  selector: 'app-de-tos-contents',
  templateUrl: './de-tos-contents.component.html',
})
export class GermanTOSContentsComponent {}
